import React, {useState, useLayoutEffect} from 'react';
import {useLocation, Link} from 'react-router-dom';

import Activ from './activ';
import './App.css';
import './market.css';
import Mpannel from './mpannel';
import {Pannel} from './pannel';
import Mativ from './mativ';
import { isMobile } from 'react-device-detect';
import axios from 'axios';
import dayjs from 'dayjs';
import {keepPreviousData, useQuery} from '@tanstack/react-query';


const Acti=({colls, jp})=>{
    const coco = useLocation();
   
    const [reshu, setreshu] = useState();

    const afnax = async (signal) => {
        const { data : hooko } = await axios.get('/api/carousel', { signal });
        return hooko;
   };

   const znx = (hooko) =>{
    const kmama = [hooko.sub1, hooko.sub2, hooko.sub3].flat();
    const keyMap = { 1: 'a', 2: 'b', 3: 'c' };
    const dade = kmama.reduce((acc, item) => {
        const key = keyMap[item.cate];
        if (key) {
          (acc[key] ||= []).push(item);
        }
        return acc;
      }, {});
      
      const data = {a : suggle(dade?.a), b : suggle(dade?.b), c : suggle(dade?.c)};
  
      return data;
   };

 const {isPending, data : last} = useQuery({queryKey:['kah', colls], queryFn: ({signal})=>afnax(signal),
 placeholderData: keepPreviousData, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 30});

   useLayoutEffect(()=>{
  
    if (!last) {
        return;
      }
    
    if (Object.keys(last).length === 0) {
        return;
      }
    
    const udang = znx(last);
    
    if(colls == "공모전"){
        setreshu(udang.a);
    }else if(colls == "대외활동"){
        setreshu(udang.b);
    }else{
        setreshu(udang.c);
    };
    document.title = colls + " - 돌파공모";
   },[colls, last]);

   const bover = isMobile ? "mover" : "cover";

   const suggle =(arar)=>{
    if(arar === undefined) return [];
    for (let i = arar.length - 1; i > 0; i--){
        let j = Math.floor(Math.random() * (i + 1));
        [arar[i], arar[j]] = [arar[j], arar[i]];
      };
      return arar;
};

return(
<>
{isMobile ? <Mpannel/> : <Pannel/>}
<div>{coco.state && coco.state.map(ele => {return <div><img src={ele.poster}/><p>{ele.titie}</p></div>})}</div>
<div className='market'>

<div className={isMobile ? "mback2" : "back2"}>
    <h3>인기 {colls}</h3>
    <div className='aa'>

    {reshu && reshu?.map((con, i)=>{ return (<div className={bover}>
        <Link to={`../../ajo/${con.link}`} className='wonche'>
            <div className='smallpic'>
              <img src={process.env.PUBLIC_URL+`/document/${con.image}`} />
            </div>
            <div className='smallmemo'>
             <p>
               <span className='day'>{reshu && dayjs(con.online).format('YYYY.M.D')}~{reshu && dayjs(con.offline).format('YYYY.M.D')}</span>
             </p>
             <p>{reshu && con.title}  <span className='end'>D-{dayjs(con.offline).startOf('day').diff(dayjs().startOf('day'),'day')}</span></p>
            </div>
            </Link>
        </div>)})}
    </div>    
</div>
</div>
{isMobile ? <Mativ colls={colls} jp={jp}/> : <Activ colls={colls} jp={jp}/>}

</>
);
}

export default Acti;